import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { useLanguage } from '../i18n/LanguageContext';
export function NotFoundPage() {
  const {
    getLink
  } = useLanguage();
  return <div className="min-h-screen bg-white flex flex-col" data-id="element-837">
      <Header data-id="element-838" />

      <main className="flex-1 flex items-center justify-center px-6 py-16" data-id="element-839">
        <div className="max-w-md text-center" data-id="element-840">
          <div className="w-20 h-20 mx-auto mb-6 rounded-full bg-gray-100 flex items-center justify-center" data-id="element-841">
            <span className="text-4xl font-bold text-gray-400" data-id="element-842">404</span>
          </div>

          <h1 className="text-2xl md:text-3xl font-bold text-[var(--color-text-dark)] mb-4" data-id="element-843">
            Page Not Found
          </h1>

          <p className="text-[var(--color-text-light)] mb-8" data-id="element-844">
            The page you're looking for doesn't exist or has been moved.
          </p>

          <div className="flex flex-col sm:flex-row gap-3 justify-center" data-id="element-845">
            <a href={getLink('/')} className="px-6 py-3 bg-[var(--color-tan)] text-white text-sm font-medium rounded-lg hover:opacity-90 transition-opacity" data-id="element-846">
              Go to Homepage
            </a>
            <a href={getLink('/specialists')} className="px-6 py-3 border border-gray-200 text-[var(--color-text-dark)] text-sm font-medium rounded-lg hover:bg-gray-50 transition-colors" data-id="element-847">
              For Seafarers
            </a>
          </div>
        </div>
      </main>

      <Footer data-id="element-848" />
    </div>;
}